import{FilterType as o}from"../cosmograph/types.js";const s={accessor:o=>o.date,filterType:o.Links};export{s as defaultCosmographTimelineConfig};
//# sourceMappingURL=config.js.map
